import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { StorageServicesService } from 'src/app/services/storage_services/storage-services.service';

import {SPORTS} from '../../assets/i18n/en.json';


@Pipe({
  name: 'translateSports'
})
export class TranslateSportsPipe implements PipeTransform {

  constructor(public translate:TranslateService,private storageService: StorageServicesService,){

  }

  transform(input): unknown {
    let selectedLan=JSON.parse(this.storageService.getLocal("language"));
    let output;
    if(selectedLan=="en"){
      output=input;
    }
    if(selectedLan!="en"){
      //this.translate.use('en');
      let english:any=SPORTS
      
      let index=0;
      for (let i = 0; i < english.length; i++) {
        if(english[i].toLowerCase()==input.toLowerCase()){
          index=i;
        }
      }
      
      this.translate.get('SPORTS').subscribe((res: string) => {
        output=res[index];
      });
    }
    
    return output;
  }

}
